<template>
    <div class="login-card">
        <div class="top-border"></div>
        <div class="login-content">
            <img :src="getLogoUrl" style="width: 100px" />
            <h1>Restablecer contraseña</h1>
            <p>Introduzca su e-mail y pulse "Restablecer". Se le enviará un correo con las instrucciones para
                restablecer su contraseña.</p>
            <div class="username-container">
                <label>E-mail</label>
                <div class="login-input">
                    <InputText ref="emailControl" placeholder="E-mail" v-model="request.user.email" />
                </div>
            </div>
            <div class="username-container">
                <label>Confirmar e-mail</label>
                <div class="login-input">
                    <InputText ref="emailConfirmControl" placeholder="Confirme su e-mail" v-model="emailconfirm" />
                </div>
            </div>
            <div class="forgetpassword-container">
                <a href="#" class="forget-password" @click="$emit('update:isForgetPassChild', false)">Volver a la página
                    de acceso.</a>
            </div>
            <div>
                <Button id="submitButton" @click="onSubmitForgotPassword" label="Restablecer" />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { computed, ref, inject } from 'vue';
import { useStore } from 'vuex';
import { Actions } from '@frontcommon/shared/src/almacen/enums/StoreEnums';
import { forgetPasswordRequest } from '@frontcommon/shared/src/interfaces/nostromo/service/forgetPasswordRequest';
import { user } from '@frontcommon/shared/src/interfaces/nostromo/service/generic/user';
import MessageService, { MessageType } from '@frontcommon/shared/src/servicios/MessageService';
import HelperCommon from '@frontcommon/shared/src/funciones/HelperCommon';
import HelperLoading from '@frontcommon/shared/src/funciones/HelperLoading';
import ConfigurationConst from '@frontcommon/shared/src/constantes/ConfigurationConst';
import PlatformType from '@frontcommon/shared/src/constantes/PlatformType';


export default {
    name: 'forgotpassword',
    props: ['isForgetPassChild'],
    emits: ['update:isForgetPassChild'],
    setup(props,context) {
        const store = useStore();
        const emailControl = ref<HTMLElement | null>(null);
        const emailConfirmControl = ref<HTMLElement | null>(null);
        const emailconfirm = ref('');
        const ipublicPath = inject('publicPath');

        const user_req: Partial<user> = {
            email: ''
        };

        const request = ref<forgetPasswordRequest>({
            user: user_req as any,
            remoteApplication: 'Portal',
            remoteIp: '',
            requestedUrl: '',
        });

        function validateData(): boolean {
            if (!validateEmail(request.value.user.email)) {
                MessageService.showMessage(MessageType.Error, 'Error de validación', 'Debe indicar un e-mail válido.');
                return false;
            }
            if (request.value.user.email != emailconfirm.value) {
                MessageService.showMessage(MessageType.Error, 'Error de validación', 'Las direcciones de e-mail no coinciden.');
                return false;
            }

            return true;
        }

        function validateEmail(email) {
            return HelperCommon.validarEmail(email);
        }

        const onSubmitForgotPassword = () => {
            // Clear existing errors
            if (validateData()) {
                // Dummy delay
                HelperLoading.showLoading();
                    // Send resetPassword request
                    store.dispatch(Actions.FORGOT_PASSWORD, request.value).then(() => {                        
                        MessageService.showToast(MessageType.Correcto, '', 'Se ha enviado el correo de reestablecimiento de contraseña correctamente.');
                        context.emit('update:isForgetPassChild');
                        //router.push({ name: 'forgotpassword' });
                    }).finally(() => {
                        HelperLoading.hideLoading();
                    });
            }
        };

        const getLogoUrl = computed(() =>{
            let urlLogo = `${ipublicPath}layout/images/logo_wp.png`;
            var platform = store.getters.getKey(ConfigurationConst.PLATFORM) ??  PlatformType.WP;            
            if (platform.toLowerCase()=== PlatformType.AM ){
                urlLogo = `${ipublicPath}layout/images/logo_aunna.png`;
            }

            return urlLogo;
        })

        return {
            request,
            emailControl,
            emailConfirmControl,
            emailconfirm,
            onSubmitForgotPassword,
            getLogoUrl,
            ipublicPath
        };
    },
};
</script>
